"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconTransport = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12,4 L5,4 C3.34,4 2,5.34 2,7 L2,15 C2,16.66 3.34,18 5,18 L4,19 L4,20 L5,20 L7,18 L9,18 L9,13 L4,13 L4,6 L13,6 L13,8 L15,8 L15,7 C15,5.34 13.66,4 12,4 Z M5,14 C5.55,14 6,14.45 6,15 C6,15.55 5.55,16 5,16 C4.45,16 4,15.55 4,15 C4,14.45 4.45,14 5,14 Z M20.57,9.66 C20.43,9.26 20.05,9 19.6,9 L12.41,9 C11.95,9 11.58,9.26 11.43,9.66 L10.01,13.77 L10.01,19.28 C10.01,19.66 10.32,20 10.7,20 L11.32,20 C11.7,20 12,19.62 12,19.24 L12,18 L20,18 L20,19.24 C20,19.62 20.31,20 20.69,20 L21.3,20 C21.68,20 21.99,19.66 21.99,19.28 L22,17.91 L22,13.77 L20.57,9.66 L20.57,9.66 Z M12.41,10 L19.6,10 L20.63,13 L11.38,13 L12.41,10 Z M12,16 C11.45,16 11,15.55 11,15 C11,14.45 11.45,14 12,14 C12.55,14 13,14.45 13,15 C13,15.55 12.55,16 12,16 Z M20,16 C19.45,16 19,15.55 19,15 C19,14.45 19.45,14 20,14 C20.55,14 21,14.45 21,15 C21,15.55 20.55,16 20,16 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconTransport')(IconTransport);